var render = function render(){var _vm=this,_c=_vm._self._c;return _c('jw-pagination',{attrs:{"items":_vm.paginData.pages,"styles":_vm.customStyles,"labels":_vm.customLabels},on:{"changePage":_vm.onChangePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }